let Pending = function() {	
	return this.InvoicesList.filter((r) => r.status === 1);
};
export default Pending;
